<template>
  <div class="card">
    <div class="row">
      <div class="col-md-12">
        <div class="handsontable table-responsive" style="max-height: 680px;" id="incomeTable">
          <table class="htCore">
            <colgroup>
              <col style="width: 100px;">
              <col style="width: 300px;">
              <col style="width: 100px;">
              <col style="width: 300px;">
              <col style="width: 200px;">
              <col style="width: 150px;">
              <col style="width: 300px;">
              <col style="width: 300px;">
            </colgroup>
            <thead>
            <tr>
              <th>
                <div class="relative">
                  <span class="colHeader">Date</span>
                </div>
              </th>
              <th>
                <div class="relative">
                  <span class="colHeader">Name</span>
                </div>
              </th>
              <th>
                <div class="relative">
                  <span class="colHeader">Amount</span>
                </div>
              </th>
              <th>
                <div class="relative">
                  <span class="colHeader">Description</span>
                </div>
              </th>
              <th>
                <div class="relative">
                  <span class="colHeader">Move to Project</span>
                </div>
              </th>
              <th>
                <div class="relative">
                  <span class="colHeader">Move to Amount</span>
                </div>
              </th>
              <th>
                <div class="relative">
                  <span class="colHeader"></span>
                </div>
              </th>
              <th>
                <div class="relative">
                  <span class="colHeader"></span>
                </div>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(record, index) in data" :key="index">
              <td class=""><input type="text" class="cell" v-model="record.date"></td>
              <td class=""><input type="text" class="cell" v-model="record.item_name"></td>
              <td class=""><input type="number" class="cell" v-model="record.amount"></td>
              <td class=""><input type="text" class="cell" v-model="record.description"></td>
              <td class="">
                <select v-model="record.project_id" class="cell">
                  <option value="0" disabled>Choose one</option>
                  <option v-for="project in projects" :value="project.project_id" :key="project.project_id">{{project.full_name}}</option>
                </select>
              </td>
              <td class=""><input type="number" class="cell" :id="'record_' + record.item_id"></td>
              <td class=""><input type="text" class="cell"></td>
              <td class=""><input type="text" class="cell"></td>
            </tr>
            <tr v-for="(record, index) in newInvData" :key="index+1+amountRows">
              <td class=""><input type="text" class="cell" v-model="record.date"></td>
              <td class=""><input type="text" class="cell" v-model="record.item_name"></td>
              <td class=""><input type="number" class="cell" v-model="record.amount"></td>
              <td class=""><input type="text" class="cell" v-model="record.description"></td>
              <td class=""><input type="text" class="cell"></td>
              <td class=""><input type="text" class="cell"></td>
              <td class=""><input type="text" class="cell"></td>
              <td class=""><input type="text" class="cell"></td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-md-3 col-xl-2" style="margin-top: 15px">
        <base-button class="clock-button" size="lg" simple type="success" @click="saveData">Save table</base-button>
      </div>
    </div>
  </div>
</template>

<script>
    import axios from "axios";
    import {setCookie, url} from "../../plugins/axios";

    export default {
      name: "inventorization-table",
      props: ['data', 'oldData', 'current', 'amountRows'],
      data(){
        return{
          projects: [],
          newRows: 0,
          invData: [],
          newInvData:[],
          maxNewRow: 50,
          newProjectId: 0,
          new_amount: [],
        }
      },
      methods:{
        getProjectForFilter(){
          axios
            .get(url + 'projects-short/',
              {
                withCredentials:'include',
                crossDomain:true
              })
            .then((response) => {
              if (response.data.error === ''){
                this.projects = response.data.result
              }
              else{
                if (response.data.error === 'Session is over'){
                  setCookie('Authentication','Failed',1);
                  this.$router.push('/login');
                }
                else{
                  this.notifyVue('danger',response.data.error);
                }
              }
            })
            .catch((error) => {
              this.notifyVue('danger',error);
            });

        },
        setUpNewRows(){
          for(let i = 0; i < this.maxNewRow; i++){
            this.newInvData[i] = {
              item_id : 0,
              date: '',
              item_name: '',
              amount: '',
              project_id: this.current,
              description: '',
            }
          }
        },
        saveData(){
          let resNewData = this.getNewData();
          const updateData = this.getUpdateData();
          for(let record in updateData){
            resNewData.push(updateData[record]);
          }
          this.$emit('save-data', resNewData);
          this.setUpNewRows();
        },
        getUpdateData(){
          let resNewData = [];
          if (JSON.stringify(this.data) === JSON.stringify(this.oldData)){return [];}
          let index = 0;
          for(let i = 0; i < this.data.length; i++){
            if (JSON.stringify(this.data[i]) !== JSON.stringify(this.oldData[i])){
              resNewData.push({});
              resNewData[index]['item_id'] = this.data[i]['item_id'];
              for(let key in this.data[i]){
                if (this.data[i][key] !== this.oldData[i][key]){
                  if (key !== 'project_id'){resNewData[index][key] = this.data[i][key];}
                  else{
                    const value = document.getElementById('record_' + this.data[i]['item_id']).value;
                    if (value === ''){resNewData[index]['project_id'] = this.data[i]['project_id'];}
                    else{
                      resNewData[index]['amount'] = this.data[i]['amount'] - value;
                      resNewData.push({});
                      index++;
                      const date = new Date();
                      resNewData[index] = {
                        item_id: 0,
                        date: date.toLocaleDateString(),
                        item_name: this.data[i]['item_name'],
                        amount: value,
                        project_id: this.data[i]['project_id']
                      };
                    }
                  }
                }
              }
              index++;
            }
          }
          return resNewData;
        },
        getNewData(){
          let resNewData = [];
          for(let i = 0; i < this.newInvData.length; i++){
            if (this.newInvData[i].item_name !== ''){
              resNewData[i] = this.newInvData[i];
              let date = new Date();
              if (this.newInvData[i].date === ''){
                this.newInvData[i].date = date.toLocaleDateString();
              }
            }
            else{break;}
          }
          return resNewData;
        }
      },

      created() {
        this.setUpNewRows();
        this.getProjectForFilter();
      }
    }
</script>

<style scoped>
  select{
    width: 200px;
    height: 24px;
    border: 1px;
  }
  .card{
    margin-top: 0;
  }
  .handsontable {
    position: relative;
  }

  .handsontable.htAutoColumnSize {
    visibility: hidden;
    left: 0;
    position: absolute;
    top: 0;
  }

  .handsontable table,
  .handsontable tbody,
  .handsontable thead,
  .handsontable td,
  .handsontable th,
  .handsontable div {
    box-sizing: content-box;
    -webkit-box-sizing: content-box;
    -moz-box-sizing: content-box;
  }

  .handsontable table.htCore {
    border-collapse: separate;
    /*it must be separate, otherwise there are offset miscalculations in WebKit: http://stackoverflow.com/questions/2655987/border-collapse-differences-in-ff-and-webkit*/
    position: relative;
    /*this actually only changes appearance of user selection - does not make text unselectable
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -o-user-select: none;
    -ms-user-select: none;
    /*user-select: none; /*no browser supports unprefixed version*/
    border-spacing: 0;
    margin: 0;
    border-width: 0;
    table-layout: fixed;
    width: 0;
    outline-width: 0;
    /* reset bootstrap table style. for more info see: https://github.com/warpech/jquery-handsontable/issues/224 */
    max-width: none;
    max-height: none;
  }

  .handsontable col {
    width: 50px;
  }

  .handsontable col.rowHeader {
    width: 50px;
  }

  .handsontable th,
  .handsontable td {
    border-right: 1px solid #CCC;
    border-bottom: 1px solid #CCC;
    height: 22px;
    empty-cells: show;
    line-height: 21px;
    padding: 0 4px 0 4px;
    /* top, bottom padding different than 0 is handled poorly by FF with HTML5 doctype */
    background-color: #FFF;
    vertical-align: top;
    overflow: hidden;
    outline-width: 0;
    white-space: pre-line;
    /* preserve new line character in cell */
  }

  .handsontable td.htInvalid {
    -webkit-transition: background 0.75s ease;
    transition: background 0.75s ease;
    background-color: #ff4c42;
  }

  .handsontable th:last-child {
    /*Foundation framework fix*/
    border-right: 1px solid #CCC;
    border-bottom: 1px solid #CCC;
  }

  .handsontable tr:first-child th.htNoFrame,
  .handsontable th:first-child.htNoFrame,
  .handsontable th.htNoFrame {
    border-left-width: 0;
    background-color: white;
    border-color: #FFF;
  }

  .handsontable th:first-child,
  .handsontable td:first-child,
  .handsontable .htNoFrame + th,
  .handsontable .htNoFrame + td {
    border-left: 1px solid #CCC;
  }

  .handsontable tr:first-child th,
  .handsontable tr:first-child td {
    border-top: 1px solid #CCC;
  }

  .handsontable thead tr:last-child th {
    border-bottom-width: 0;
  }

  .handsontable thead tr.lastChild th {
    border-bottom-width: 0;
  }

  .handsontable th {
    background-color: #EEE;
    color: #222;
    text-align: center;
    font-weight: normal;
    white-space: nowrap;
  }

  .handsontable thead th {
    padding: 0;
  }

  .handsontable th.active {
    background-color: #CCC;
  }

  .handsontable thead th .relative {
    position: relative;
    padding: 2px 4px;
  }

  /* plugins */

  .handsontable .manualColumnMover {
    position: absolute;
    left: 0;
    top: 0;
    background-color: transparent;
    width: 5px;
    height: 25px;
    z-index: 999;
    cursor: move;
  }

  .handsontable th .manualColumnMover:hover,
  .handsontable th .manualColumnMover.active {
    background-color: #88F;
  }

  .handsontable .manualColumnResizer {
    position: absolute;
    top: 0;
    cursor: col-resize;
  }

  .handsontable .manualColumnResizerHandle {
    background-color: transparent;
    width: 5px;
    height: 25px;
  }

  .handsontable .manualColumnResizer:hover .manualColumnResizerHandle,
  .handsontable .manualColumnResizer.active .manualColumnResizerHandle {
    background-color: #AAB;
  }

  .handsontable .manualColumnResizerLine {
    position: absolute;
    right: 0;
    top: 0;
    background-color: #AAB;
    display: none;
    width: 0;
    border-right: 1px dashed #777;
  }

  .handsontable .manualColumnResizer.active .manualColumnResizerLine {
    display: block;
  }

  .handsontable .columnSorting:hover {
    text-decoration: underline;
    cursor: pointer;
  }

  /* border line */

  .handsontable .wtBorder {
    position: absolute;
    font-size: 0;
  }

  .handsontable td.area {
    background-color: #EEF4FF;
  }

  /* fill handle */

  .handsontable .wtBorder.corner {
    font-size: 0;
    cursor: crosshair;
  }

  .handsontable .htBorder.htFillBorder {
    background: red;
    width: 1px;
    height: 1px;
  }

  .handsontableInput {
    border: 2px solid #5292F7;
    outline-width: 0;
    margin: 0;
    padding: 1px 4px 0 2px;
    font-family: Arial, Helvetica, sans-serif;
    /*repeat from .handsontable (inherit doesn't work with IE<8) */
    line-height: 1.3em;
    /*repeat from .handsontable (inherit doesn't work with IE<8) */
    font-size: inherit;
    -webkit-box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.4);
    box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.4);
    resize: none;
    /*below are needed to overwrite stuff added by jQuery UI Bootstrap theme*/
    display: inline-block;
    color: #000;
    border-radius: 0;
    background-color: #FFF;
    /*overwrite styles potentionally made by a framework*/
  }

  .handsontableInputHolder {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;
  }

  .htSelectEditor {
    -webkit-appearance: menulist-button !important;
    position: absolute;
  }

  /*
  TextRenderer readOnly cell
  */

  .handsontable .htDimmed {
    color: #777;
  }

  /*
  TextRenderer placeholder value
  */

  .handsontable .htPlaceholder {
    color: #999;
  }

  /*
  AutocompleteRenderer down arrow
  */

  .handsontable .htAutocompleteArrow {
    float: right;
    font-size: 10px;
    color: #EEE;
    cursor: default;
    width: 16px;
    text-align: center;
  }

  .handsontable td .htAutocompleteArrow:hover {
    color: #777;
  }

  /*
  CheckboxRenderer
  */

  .handsontable .htCheckboxRendererInput.noValue {
    opacity: 0.5;
  }

  /*
  NumericRenderer
  */

  .handsontable .htNumeric {
    text-align: right;
  }

  /*context menu rules*/

  ul.context-menu-list {
    color: black;
  }

  ul.context-menu-list li {
    margin-bottom: 0;
    /*Foundation framework fix*/
  }

  /**
   * dragdealer
   */

  .handsontable .dragdealer {
    position: relative;
    width: 9px;
    height: 9px;
    background: #F8F8F8;
    border: 1px solid #DDD;
  }

  .handsontable .dragdealer .handle {
    position: absolute;
    width: 9px;
    height: 9px;
    background: #C5C5C5;
  }

  .handsontable .dragdealer .disabled {
    background: #898989;
  }

  /**
   * Handsontable in Handsontable
   */

  .handsontable .handsontable .wtHider {
    padding: 0 0 5px 0;
  }

  .handsontable .handsontable table {
    -webkit-box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.4);
    box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.4);
  }

  /**
   * Handsontable listbox theme
   */

  .handsontable.listbox {
    margin: 0;
  }

  .handsontable.listbox table {
    border: 1px solid #ccc;
    border-collapse: separate;
    background: white;
  }

  .handsontable.listbox th,
  .handsontable.listbox tr:first-child th,
  .handsontable.listbox tr:last-child th,
  .handsontable.listbox tr:first-child td,
  .handsontable.listbox td {
    border-width: 0;
  }

  .handsontable.listbox th,
  .handsontable.listbox td {
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .handsontable.listbox td.htDimmed {
    cursor: default;
    color: inherit;
    font-style: inherit;
  }

  .handsontable.listbox .wtBorder {
    visibility: hidden;
  }

  .handsontable.listbox tr td.current,
  .handsontable.listbox tr:hover td {
    background: #eee;
  }

  .htContextMenu {
    display: none;
    position: absolute;
  }

  .htContextMenu table.htCore {
    outline: 1px solid #bbb;
  }

  .htContextMenu .wtBorder {
    visibility: hidden;
  }

  .htContextMenu table tbody tr td {
    background: white;
    border-width: 0;
    padding: 4px 6px 0px 6px;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .htContextMenu table tbody tr td:first-child {
    border: 0;
  }

  .htContextMenu table tbody tr td.htDimmed{
    font-style: normal;
    color: #323232;
  }

  .htContextMenu table tbody tr td.current{
    background: rgb(233, 233, 233);
  }

  .htContextMenu table tbody tr td.htSeparator {
    border-top: 1px solid #bbb;
    height: 0;
    padding: 0;
  }

  .htContextMenu table tbody tr td.htDisabled {
    color: #999;
  }

  .htContextMenu table tbody tr td.htDisabled:hover {
    background: white;
    color: #999;
    cursor: default;
  }

  .handsontable td.htSearchResult {
    background: #fcedd9;
    color: #583707;
  }

  /*WalkontableDebugOverlay*/

  .wtDebugHidden {
    display: none;
  }

  .wtDebugVisible {
    display: block;
    -webkit-animation-duration: 0.5s;
    -webkit-animation-name: wtFadeInFromNone;
    animation-duration: 0.5s;
    animation-name: wtFadeInFromNone;
  }

  @keyframes wtFadeInFromNone {
    0% {
      display: none;
      opacity: 0;
    }

    1% {
      display: block;
      opacity: 0;
    }

    100% {
      display: block;
      opacity: 1;
    }
  }

  @-webkit-keyframes wtFadeInFromNone {
    0% {
      display: none;
      opacity: 0;
    }

    1% {
      display: block;
      opacity: 0;
    }

    100% {
      display: block;
      opacity: 1;
    }
  }

  .handsontable tbody td {
    margin:0; padding:0;
    padding-right:0px;
  }

  input {
    border:none;
    width:100%;
    height:100%;
    font-family: Verdana, Helvetica, Arial, FreeSans, sans-serif;
    font-size:12px;
    padding: 0 4px 0 4px;

  }

  input:focus {
    border:2px solid #5292F7;
    outline: none;
    font-weight: 600;
    color: black;
  }
  select:focus {
    border:2px solid #5292F7;
    outline: none;
    font-weight: 600;
    color: black;
  }

  .table-fixed-head {
    table-layout: fixed;
    border-collapse: collapse;
  }

  .table-fixed-head thead tr {
    display: block;
    position: relative;
  }

  .table-fixed-head tbody {
    display: block;
    overflow: hidden;
  }

  select option {
    margin: 40px;
    background: rgb(51, 37, 106);
    color: #fff;
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4);
  }

  .self-building-square-spinner, .self-building-square-spinner * {
    box-sizing: border-box;
  }

  .self-building-square-spinner {
    height: 40px;
    width: 40px;

    position: absolute;
    top: 40%;
  }

  .self-building-square-spinner .square {
    height: 10px;
    width: 10px;
    top: calc( -10px * 2 / 3);
    margin-right: calc(10px / 3);
    margin-top: calc(10px / 3);
    background: #ff1d5e;
    float: left;
    position:relative;
    opacity: 0;
    animation: self-building-square-spinner 6s infinite;
  }

  .self-building-square-spinner .square:nth-child(1) {
    animation-delay: calc(300ms * 6);
  }

  .self-building-square-spinner .square:nth-child(2) {
    animation-delay: calc(300ms * 7);
  }

  .self-building-square-spinner .square:nth-child(3) {
    animation-delay: calc(300ms * 8);
  }

  .self-building-square-spinner .square:nth-child(4) {
    animation-delay: calc(300ms * 3);
  }

  .self-building-square-spinner .square:nth-child(5) {
    animation-delay: calc(300ms * 4);
  }

  .self-building-square-spinner .square:nth-child(6) {
    animation-delay: calc(300ms * 5);
  }

  .self-building-square-spinner .square:nth-child(7) {
    animation-delay: calc(300ms * 0);
  }

  .self-building-square-spinner .square:nth-child(8) {
    animation-delay: calc(300ms * 1);
  }

  .self-building-square-spinner .square:nth-child(9) {
    animation-delay: calc(300ms * 2);
  }

  .self-building-square-spinner .clear{
    clear: both;
  }

  @keyframes self-building-square-spinner {
    0% {
      opacity: 0;
    }
    5% {
      opacity: 1;
      top: 0;
    }
    50.9% {
      opacity: 1;
      top: 0;
    }
    55.9% {
      opacity: 0;
      top: inherit;
    }
  }
</style>
